const prefersReducedMotion = { current: null };
const hasReducedMotionListener = { current: false };
export {
  hasReducedMotionListener,
  prefersReducedMotion
};
